export default __webpack_public_path__ + "static/DigVentures-5d52b9cd8d3a3d5f5ff3aacf35ea6f25.svg";